import React from 'react';
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from './pages/Home';
import AddBook from './pages/AddBook';
import EditBook from './pages/EditBook';

export default function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/add-book" element={<AddBook />} />
      <Route path="/edit-book/:bookId" element={<EditBook />} />
      <Route path="*" element={<h1 style={{ color: "white" }}>No match</h1>} />
    </Routes>
  </BrowserRouter>
  )
}
